export default __webpack_public_path__ + "static/media/icon-next.a4224507.svg";